export default "__VITE_ASSET__Bhm0RMgH__"